import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-header',
  imports: [
     MatIconModule
  ],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  @Input() icon:string = '';
  @Output() iconClickedEvent : EventEmitter<any> = new EventEmitter();

  iconClicked(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    this.iconClickedEvent.emit();
  }

}
